import { render, staticRenderFns } from "./SelectCombo.vue?vue&type=template&id=196482ca&"
import script from "./SelectCombo.vue?vue&type=script&lang=js&"
export * from "./SelectCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports